<template>
  <main id="maincontent" class="page-main">
    <a id="contentarea" tabindex="-1"></a>
    <div class="page messages">
      <div data-placeholder="messages"></div>
      <div data-bind="scope: 'messages'">
        <!-- ko if: cookieMessages && cookieMessages.length > 0 --><!-- /ko -->
        <!-- ko if: messages().messages && messages().messages.length > 0 --><!-- /ko -->
      </div>
    </div>

    <div class="columns">
      <!-- Colonne principale -->
      <div class="column main">
        <div class="page-title-wrapper">
          <h1 class="page-title">
            <span class="base" data-ui-id="page-title-wrapper">Carnet d’adresses</span>
          </h1>
        </div>
        <input name="form_key" type="hidden" :value="formKey" />

        <!-- Adresses par défaut -->
        <div class="block block-addresses-default">
          <div class="block-title">
            <strong>Adresses par défaut</strong>
          </div>
          <div class="block-content">
            <div class="box box-address-billing">
              <strong class="box-title">
                <span>Adresse de facturation par défaut</span>
              </strong>
              <div class="box-content">
                <address>
                  {{ billingAddress.name }}<br />
                  {{ billingAddress.street }}<br />
                  {{ billingAddress.email }}<br />
                  {{ billingAddress.city }}, {{ billingAddress.postcode }}<br />
                  {{ billingAddress.country }}<br />
                  T: {{ billingAddress.phone }}
                </address>
              </div>
              <div class="box-actions">
                <a class="action edit" :href="editBillingAddressUrl">
                  <span>Modifier l’adresse de facturation</span>
                </a>
              </div>
            </div>

            <div class="box box-address-shipping">
              <strong class="box-title">
                <span>Adresse de livraison par défaut</span>
              </strong>
              <div class="box-content">
                <address>
                  {{ shippingAddress.name }}<br />
                  {{ shippingAddress.street }}<br />
                  {{ shippingAddress.email }}<br />
                  {{ shippingAddress.city }}, {{ shippingAddress.postcode }}<br />
                  {{ shippingAddress.country }}<br />
                  T: {{ shippingAddress.phone }}
                </address>
              </div>
              <div class="box-actions">
                <a class="action edit" :href="editShippingAddressUrl">
                  <span>Modifier</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Adresses supplémentaires -->
        <div class="block block-addresses-list">
          <div class="block-title">
            <strong>Saisies d’adresses supplémentaires</strong>
          </div>
          <div class="block-content">
            <p class="empty" v-if="!additionalAddresses.length">
              Vous n’avez pas d’autres adresses dans votre carnet d’adresses.
            </p>
          </div>
        </div>

        <!-- Actions -->
        <div class="actions-toolbar">
          <div class="primary">
            <button
              type="button"
              role="add-address"
              title="Ajouter une nouvelle adresse"
              class="action primary add"
              @click="addNewAddress"
            >
              <span>Ajouter une nouvelle adresse</span>
            </button>
          </div>
          <div class="secondary">
            <a class="action back" :href="accountUrl">
              <span>Retour</span>
            </a>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="sidebar sidebar-main">
        <div class="block block-collapsible-nav">
          <div class="title block-collapsible-nav-title">
            <strong>Mon compte</strong>
          </div>
          <div class="content block-collapsible-nav-content" id="block-collapsible-nav">
            <ul class="nav items">
              <li class="nav item">
                <a :href="accountUrl">Mon compte</a>
              </li>
              <li class="nav item">
                <a :href="orderHistoryUrl">Mes commandes</a>
              </li>
              <li class="nav item">
                <a :href="searchAgentsUrl">Mes recherche-agents</a>
              </li>
              <li class="nav item">
                <a :href="offerListUrl">Ma liste d'offres</a>
              </li>
              <li class="nav item">
                <a :href="offerFilesUrl">Ma liste de fichiers d'offres</a>
              </li>
              <li class="nav item">
                <span class="delimiter"></span>
              </li>
              <li class="nav item current">
                <strong>Carnet d’adresses</strong>
              </li>
              <li class="nav item">
                <a :href="editAccountUrl">Informations du compte</a>
              </li>
              <li class="nav item">
                <a :href="savedPaymentMethodsUrl">Moyens de paiement enregistrés</a>
              </li>
              <li class="nav item">
                <span class="delimiter"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
    name:"AdressI",
  data() {
    return {
      formKey: "1RXMEivafAHbQJmt", // Clé de formulaire
      billingAddress: {
        name: "Monsieur BRAHIM SOBAI",
        street: "cmm",
        email: "cmmmaroc99@gmail.com",
        city: "CASABLANCA",
        postcode: "209000",
        country: "Maroc",
        phone: "0667791380",
      },
      shippingAddress: {
        name: "Monsieur BRAHIM SOBAI",
        street: "cmm",
        email: "cmmmaroc99@gmail.com",
        city: "CASABLANCA",
        postcode: "209000",
        country: "Maroc",
        phone: "0667791380",
      },
      additionalAddresses: [], // Liste des adresses supplémentaires
      accountUrl: "https://shop.labexchange.com/fr/customer/account/",
      orderHistoryUrl: "https://shop.labexchange.com/fr/sales/order/history/",
      searchAgentsUrl: "https://shop.labexchange.com/fr/suchagent/",
      offerListUrl: "https://shop.labexchange.com/fr/offerlist/",
      offerFilesUrl: "https://shop.labexchange.com/fr/offerlist/index/offers/",
      editAccountUrl: "https://shop.labexchange.com/fr/customer/account/edit/",
      savedPaymentMethodsUrl: "https://shop.labexchange.com/fr/vault/cards/listaction/",
      editBillingAddressUrl: "https://shop.labexchange.com/fr/customer/address/edit/id/10849/",
      editShippingAddressUrl: "https://shop.labexchange.com/fr/customer/address/edit/id/10849/",
    };
  },
  methods: {
    addNewAddress() {
      // Logique pour ajouter une nouvelle adresse
      alert("Ajouter une nouvelle adresse");
    },
  },
};
</script>

<style scoped>
/* Styles de base */
.page-main {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.columns {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.column.main {
  flex: 1 1 70%;
}

.sidebar.sidebar-main {
  flex: 1 1 25%;
}

.page-title-wrapper {
  margin-bottom: 20px;
}

.page-title {
  font-size: 24px;
  color: #333;
}

.block {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
}

.block-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
}

.box {
  margin-bottom: 15px;
}

.box-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.box-content {
  margin-bottom: 10px;
}

.box-actions {
  display: flex;
  gap: 10px;
}

.action {
  color: #007bff;
  text-decoration: none;
}

.action:hover {
  text-decoration: underline;
}

.actions-toolbar {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.actions-toolbar .primary .action.primary {
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  text-decoration: none;
}

.actions-toolbar .primary .action.primary:hover {
  background-color: #0056b3;
}

.actions-toolbar .secondary .action.back {
  color: #333;
}

.nav.items {
  list-style: none;
  padding: 0;
}

.nav.item {
  margin-bottom: 10px;
}

.nav.item a {
  color: #333;
  text-decoration: none;
}

.nav.item a:hover {
  color: #007bff;
}

.delimiter {
  display: block;
  border-top: 1px solid #ddd;
  margin: 10px 0;
}

/* Styles pour les tablettes (max-width: 1024px) */
@media (max-width: 1024px) {
  .columns {
    flex-direction: column;
  }

  .column.main,
  .sidebar.sidebar-main {
    flex: 1 1 100%;
  }

  .block {
    padding: 15px;
  }

  .page-title {
    font-size: 22px;
  }

  .block-title {
    font-size: 18px;
  }

  .box-title {
    font-size: 16px;
  }
}

/* Styles pour les mobiles (max-width: 768px) */
@media (max-width: 768px) {
  .page-main {
    padding: 10px;
  }

  .page-title {
    font-size: 20px;
    text-align: center;
  }

  .block {
    padding: 10px;
  }

  .block-title {
    font-size: 16px;
  }

  .box-title {
    font-size: 14px;
  }

  .box-actions {
    flex-direction: column;
    gap: 5px;
  }

  .actions-toolbar {
    flex-direction: column;
    gap: 10px;
  }

  .actions-toolbar .primary .action.primary {
    width: 100%;
    text-align: center;
  }
}

/* Styles pour les très petits écrans (max-width: 480px) */
@media (max-width: 480px) {
  .page-title {
    font-size: 18px;
  }

  .block {
    padding: 8px;
  }

  .block-title {
    font-size: 14px;
  }

  .box-title {
    font-size: 12px;
  }

  .box-content {
    font-size: 12px;
  }

  .action {
    font-size: 12px;
  }

  .nav.item {
    margin-bottom: 6px;
  }

  .nav.item a {
    font-size: 12px;
  }
}
</style>